import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

interface GridEditButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'default' | 'error' | 'info' | 'success' | 'warning';
  tooltip?: string;
  fontSize?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

const GridEditButton: React.FC<GridEditButtonProps> = ({
  onClick,
  ariaLabel = 'Editar',
  size = 'small',
  color = 'primary',
  tooltip,
  fontSize = 'small',
  disabled = false,
}) => {
  const button = (
    <IconButton
      color={color}
      onClick={onClick}
      size={size}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      <EditIcon fontSize={fontSize} />
    </IconButton>
  );

  // Wrap in span when disabled to allow tooltip to show
  const wrappedButton = disabled ? <span>{button}</span> : button;

  return tooltip ? (
    <Tooltip title={tooltip}>
      {wrappedButton}
    </Tooltip>
  ) : wrappedButton;
};

export default GridEditButton;